import { Grid, Typography } from "@mui/material";

const CatalogueDiagnosis = ({
  title,
  content,
}: {
  title: string;
  content: string;
}) => (
  <Grid
    direction="column"
    justifyContent="flex-start"
    alignItems="flex-start"
    sx={{ mb: 2, bgcolor: "#ECF5FA", p: 1.5 }}
  >
    <Typography sx={{ fontSize: 18, fontWeight: "bold", textAlign: "start" }}>
      {title}
    </Typography>
    <Typography
      paragraph
      textAlign="justify"
      style={{ whiteSpace: "pre-line" }}
      sx={{ m: 0 }}
    >
      {content || ""}
    </Typography>
  </Grid>
);

export default CatalogueDiagnosis;
